import {FETCH_COMPANY_USERS, USER_AUTH} from "@/store/actions.type";
import {SET_COMPANY_USERS, SET_LOADING, SET_USER} from "@/store/mutations.type";
import {UserService} from "@/common/api";
import {defaultLocale} from "@/common/config";

const state = {
	user: null,
	userLocale: (navigator.languages !== undefined ? navigator.languages[0] : navigator.language) || defaultLocale,
	companyUsers: []
};

const getters = {
	user: state => state.user,
	companyUsers: state => state.companyUsers
};

const actions = {
	async [USER_AUTH]({commit}) {
		commit(SET_LOADING, true);
		return UserService.auth()
			.then(({data}) => {
				commit(SET_USER, data.object);
				commit(SET_LOADING, false);
			})
			.catch(error => {
				throw new Error(error);
			})
	},
	async [FETCH_COMPANY_USERS]({commit}) {
		return UserService.getCompanyUsers()
			.then(({data}) => {
				commit(SET_COMPANY_USERS, data.objects);
			})
			.catch(error => {
				throw new Error(error);
			})
	}
};

const mutations = {
	[SET_USER](state, user) {
		state.user = user;
	},
	[SET_COMPANY_USERS](state, users) {
		state.companyUsers = users;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};